import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const loginFormSchema: yup.ObjectSchema<LoginFormSchema> = yup
  .object({
    email: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .email()
      .required()
      .label("Email"),
    password: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Password"),
  })
  .required();

export const LOGIN_SCHEMA_DEFAULT_VALUES = {
  email: "",
  password: "",
};
export type LoginFormSchema = typeof LOGIN_SCHEMA_DEFAULT_VALUES;

export const forgotPasswordFormSchema: yup.ObjectSchema<ForgotPasswordFormSchema> =
  yup
    .object({
      email: yup
        .string()
        .trim()
        .min(1, getStringRequiredFieldMessage)
        .email()
        .required()
        .label("Email"),
    })
    .required();

export const FORGOT_PASSWORD_SCHEMA_DEFAULT_VALUES = {
  email: "",
};
export type ForgotPasswordFormSchema =
  typeof FORGOT_PASSWORD_SCHEMA_DEFAULT_VALUES;

export const passwordRules = {
  lowercaseLetter: "Contain a lowercase letter",
  uppercaseLetter: "Contain an uppercase letter",
  number: "Contain a number",
  specialCharacter: "Contain a special character",
  noLeadingTrailingSpaces: "Not contain leading or trailing spaces",
  minLength: "Be at least 12 characters long",
};

const newPasswordValidation = yup
  .string()
  .trim()
  .required("Password is required")
  .matches(/[a-z]/, passwordRules.lowercaseLetter)
  .matches(/[A-Z]/, passwordRules.uppercaseLetter)
  .matches(/[0-9]/, passwordRules.number)
  .matches(/[!@#$%^&*(),.?":{}|<>]/, passwordRules.specialCharacter)
  .matches(/^\S*$/, passwordRules.noLeadingTrailingSpaces)
  .min(12, passwordRules.minLength);

const newPassword2Valitation = yup
  .string()
  .trim()
  .required("Confirm Password is required")
  .label("Confirm Password")
  .oneOf([yup.ref("newPassword")], "Passwords must match");

export const resetPasswordFormSchema: yup.ObjectSchema<ResetPasswordFormSchema> =
  yup
    .object({
      newPassword: newPasswordValidation,
      newPassword2: newPassword2Valitation,
      code: yup.string().trim().required("Code is required").label("Code"),
    })
    .required();

export const RESET_PASSWORD_SCHEMA_DEFAULT_VALUES = {
  newPassword: "",
  newPassword2: "",
  code: "",
};
export type ResetPasswordFormSchema =
  typeof RESET_PASSWORD_SCHEMA_DEFAULT_VALUES;

// AUTH CHALLENGE - NEW_PASSWORD_REQUIRED
export const authChallengeNewPasswordRequiredFormSchema: yup.ObjectSchema<AuthChallengeNewPasswordRequiredFormSchema> =
  yup
    .object({
      newPassword: newPasswordValidation,
      newPassword2: newPassword2Valitation,
    })
    .required();

export const AUTH_CHALLENGE_NEW_PASSWORD_REQUIRED_SCHEMA_DEFAULT_VALUES = {
  newPassword: "",
  newPassword2: "",
};
export type AuthChallengeNewPasswordRequiredFormSchema =
  typeof AUTH_CHALLENGE_NEW_PASSWORD_REQUIRED_SCHEMA_DEFAULT_VALUES;
